<template>
  <div class="page-container" :class="{ mobile: isMobile }">
    <el-container class="main-wrapper">
      <!-- 顶部导航 -->
      <div class="header">
        <div
          class="mobile-menu-btn"
          :style="{ display: isMobile ? 'block' : 'none' }"
          @click="mobileSidebarOpen = !mobileSidebarOpen"
        >
          <i class="el-icon-menu"></i>
        </div>

        <p
          class="header_left"
          :style="{ display: isMobile ? 'none' : 'block' }"
        >
          星核魔玩
        </p>

        <div class="header_right">
          <span
            @click="status"
            class="header_icon pc-menu-btn"
            :style="{ display: isMobile ? 'none' : 'block' }"
          >
            <i :class="icon" style="font-size: 26px; color: #fff"></i>
          </span>

          <!-- 新增：主题切换按钮 -->
          <span class="theme-switch" @click="toggleTheme">
            {{ theme === 'light' ? '🌞 白天' : '🌙 夜晚' }}
          </span>

          <!-- 用户信息 + 下拉卡片 -->
          <el-dropdown class="user-dropdown">
            <div class="user-info">
              <div class="avatar">
                <img
                  src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZCBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiIGZpbGw9IiM0MDlFRkYiLz48cGF0aCBkPSJNNzAgNDBjMCAxMS01IDIwLTIwIDIwUzMwIDUxIDMwIDQwUzQxIDIwIDUwIDIwczIwIDkgMjAgMjB6TTY1IDc1YzAgMTAtNyAyMC0xNSAyMHMtMTUtMTAtMTUtMjBjMC01IDE1LTggMTUtOHMxNSAzIDE1IDh6IiBmaWxsPSJ3aGl0ZSIvPjwvc3ZnPg=="
                  alt="头像"
                />
              </div>
              <span class="name">{{ userData.username || "管理员" }}</span>
              <i class="el-icon-arrow-down"></i>
            </div>

            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item @click.native="password" divided>
                <i class="el-icon-key menu-icon"></i>
                <span>重置密码</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout" class="logout-item">
                <i class="el-icon-switch-button menu-icon"></i>
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <el-container class="content-wrapper">
        <div
          class="sidebar-overlay"
          v-if="mobileSidebarOpen"
          @click="mobileSidebarOpen = false"
        ></div>

        <el-aside
          :width="isMobile ? '220px' : isCollapse ? '65px' : '200px'"
          class="sidebar"
          :class="{ 'mobile-show': mobileSidebarOpen }"
        >
          <el-menu
            unique-opened
            :collapse="!isMobile && isCollapse"
            router
            :default-active="onRouter"
            class="sidebar-menu"
            @select="
              () => {
                mobileSidebarOpen = false;
              }
            "
          >
            <el-menu-item index="index">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu
              :index="item.name"
              v-for="item in menuData"
              :key="item.id"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                :index="value.url"
                v-for="value in item.children"
                :key="value.id"
                @click="tag(value)"
              >
                <i :class="value.icon"></i>{{ value.name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>

        <el-main class="main-container">
          <!-- 标签栏 + 一键清除按钮 -->
          <div class="tags-wrapper" v-if="tagStatus">
            <div class="tags">
              <el-tag
                :key="index"
                @click="select(tag.url)"
                v-for="(tag, index) in tags"
                :effect="tag.url === $route.name ? 'dark' : 'plain'"
                closable
                @close="unTag(index)"
                class="tag-item"
              >
                {{ tag.name }}
              </el-tag>
            </div>
            <!-- 一键清除按钮 -->
            <el-button
              v-if="tags.length > 5"
              type="primary"
              icon="el-icon-delete"
              size="mini"
              @click="clearAllTags"
              class="clear-tags-btn"
            >
              一键清除
            </el-button>
          </div>

          <div class="content-box">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import api from "@/api/api.js";
// 引入主题工具函数
import { getTheme, setTheme } from "@/utils/theme";

export default {
  name: "Home",
  data() {
    return {
      isMobile: false,
      menuData: [],
      userData: {},
      isCollapse: false,
      icon: "el-icon-s-fold",
      tags: [],
      mobileSidebarOpen: false,
      // 当前主题
      theme: ""
    };
  },
  created() {
    // 初始化主题
    this.theme = getTheme();
    this.getMenu();
    this.checkDevice();
    this.tags = localStorage.getItem("tags")
      ? JSON.parse(localStorage.getItem("tags"))
      : [];
  },
  mounted() {
    window.addEventListener("resize", this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
  },
  computed: {
    onRouter() {
      return this.$route.name;
    },
    tagStatus() {
      return this.tags.length > 0;
    },
  },
  methods: {
    // 切换主题
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      setTheme(this.theme);
    },

    // ========== 核心：纯 JS 判断设备 ==========
    checkDevice() {
      const userAgent = navigator.userAgent || "";
      const mobile =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent
        );
      const smallScreen = window.innerWidth <= 768;
      this.isMobile = mobile || smallScreen;
    },

    getMenu() {
      localStorage.setItem("login", 1);
      this.$store.commit("login", true);
      this.menuData = JSON.parse(localStorage.getItem("menu"));
      this.userData = JSON.parse(localStorage.getItem("userData"));
    },
    tag(value) {
      this.tags = localStorage.getItem("tags")
        ? JSON.parse(localStorage.getItem("tags"))
        : [];
      if (!this.tags.some((t) => t.url == value.url)) {
        this.tags.push(value);
        if (this.tags.length > 3) {
          this.tags.shift();
        }
        localStorage.setItem("tags", JSON.stringify(this.tags));
      }
    },
    unTag(index) {
      if (this.$route.name === this.tags[index].url) {
        if (index === 0) {
          this.$router.push("/index");
        } else {
          window.history.back();
        }
      }
      this.tags.splice(index, 1);
      localStorage.setItem("tags", JSON.stringify(this.tags));
    },
    select(url) {
      this.$router.push(url);
    },
    // 一键清空所有标签
    clearAllTags() {
      this.$msgbox
        .confirm("确定要清空所有标签页吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.tags = [];
          localStorage.removeItem("tags");
          this.$router.push("/index");
          this.$message.success("已清空所有标签页");
        })
        .catch(() => {
          this.$message.info("已取消清空");
        });
    },
    logout() {
      this.$msgbox({
        title: "退出登录",
        message: `<div style="text-align:center; padding:10px 0;">
                    <i class="el-icon-warning" style="font-size:32px; color:#F56C6C; margin-bottom:12px; display:block;"></i>
                    <p style="font-size:15px; color:#333; margin:0;">确定要退出当前账号吗？</p>
                    <p style="font-size:13px; color:#909399; margin-top:6px;">退出后将清空登录信息，需重新登录</p>
                  </div>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: "确认退出",
        cancelButtonText: "取消",
        confirmButtonClass: "confirm-logout-btn",
        cancelButtonClass: "cancel-logout-btn",
        center: true,
        customClass: "logout-dialog",
      })
        .then(() => {
          api.common
            .logout()
            .then((res) => {
              if (res.data.code == 1000) {
                localStorage.removeItem("login");
                localStorage.removeItem("tags");
                this.$store.commit("login", false);
                this.$router.push("/login");
              }
            })
            .catch((err) => console.log(err));
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消退出" });
        });
    },
    password() {
      this.$router.push("/password");
    },
    status() {
      this.isCollapse = !this.isCollapse;
      this.icon = this.isCollapse ? "el-icon-s-unfold" : "el-icon-s-fold";
    },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

.page-container {
  height: 100vh;
  overflow: hidden;

  // ========== PC 样式 ==========
  .main-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(var(--el-color-primary), #33b3fb);
    border-radius: 6px;
  }
  ::-webkit-scrollbar-track {
    background: var(--bg-page);
  }

  .header {
    background: linear-gradient(135deg, #2c5edf 0%, #409eff 40%, #22d3ee 100%);
    height: 60px;
    display: flex;
    align-items: center;
    color: #fff;
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.2);
    position: relative;
    z-index: 100;
    backdrop-filter: blur(10px);

    .mobile-menu-btn {
      font-size: 22px;
      padding: 0 16px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: rotate(90deg);
      }
      &:active {
        transform: scale(0.92);
      }
    }

    .header_left {
      width: 200px;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
      flex-shrink: 0;
      text-shadow: 0 2px 10px rgba(255, 255, 255, 0.2);
    }

    .header_right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
      padding-right: 24px;
    }

    .header_icon {
      width: 70px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        transform: scale(1.05);
      }
    }

    /* 主题切换按钮样式 */
    .theme-switch {
      padding: 0 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s ease;
      user-select: none;
      border-radius: 8px;
      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
    }

    .user-info {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px;
      border-radius: 30px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        transform: translateY(-1px);
      }

      .avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid rgba(255, 255, 255, 0.4);
        transition: all 0.3s ease;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &:hover .avatar {
        transform: scale(1.08);
        border-color: rgba(255, 255, 255, 0.8);
      }

      .name {
        font-size: 15px;
        font-weight: 600;
      }

      i {
        font-size: 12px;
        margin-left: -2px;
        transition: all 0.3s ease;
      }
      &:hover i {
        transform: rotate(180deg);
      }
    }
  }

  // ========== 炫酷用户下拉菜单 ==========
  .user-dropdown-menu {
    border: none;
    border-radius: 12px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    padding: 0;
    overflow: hidden;
    min-width: 190px;
    background: var(--bg-card);
    animation: dropdownFade 0.3s ease;

    @keyframes dropdownFade {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .user-card {
      background: linear-gradient(135deg, #f0f7ff 0%, #e0f2ff 100%);
      padding: 18px;
      text-align: center;
      color: var(--text-primary);

      .user-avatar {
        width: 68px;
        height: 68px;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 auto 10px;
        border: 3px solid #fff;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .user-name {
        font-size: 16px;
        font-weight: 600;
      }
      .user-desc {
        font-size: 12px;
        color: var(--text-regular);
        margin-top: 4px;
      }
    }

    .el-dropdown-menu__item {
      line-height: 44px;
      padding: 0 18px;
      margin: 0;
      border-radius: 0;
      font-size: 14px;
      color: var(--text-primary);
      display: flex;
      align-items: center;
      gap: 10px;
      transition: all 0.25s ease;

      &:hover {
        background: var(--bg-page);
        color: #2c5edf;
        padding-left: 22px;
      }
    }

    .menu-icon {
      font-size: 16px;
      color: var(--el-color-primary);
    }

    .logout-item {
      color: #f56c6c;

      &:hover {
        background: #fef0f0;
        color: #f56c6c;
      }
      .menu-icon {
        color: #f56c6c;
      }
    }
  }

  .content-wrapper {
    flex: 1;
    display: flex;
    overflow: hidden;
    position: relative;
  }

  .sidebar-overlay {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 98;
    animation: fadeIn 0.25s ease;
    backdrop-filter: blur(4px);
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .sidebar {
    background: var(--bg-card);
    border-right: 1px solid var(--border-base);
    transition: all 0.32s cubic-bezier(0.25, 0.8, 0.25, 1);
    z-index: 99;
    height: 100%;
    box-shadow: 3px 0 15px rgba(0, 0, 0, 0.05);
    overflow-x: hidden !important;
    .sidebar-menu {
      height: 100%;
      border-right: none;
      overflow-x: hidden !important;
      background: var(--bg-card);
    }

    .el-menu-item,
    .el-submenu__title {
      height: 52px !important;
      line-height: 52px !important;
      margin: 6px 10px;
      border-radius: 14px;
      transition: all 0.25s ease;
      font-weight: 500;
      color: var(--text-primary);

      &:hover {
        background: #f0f7ff !important;
        transform: translateX(3px);
      }
    }

    .el-menu-item.is-active {
      background: linear-gradient(135deg, #2c5edf 0%, #409eff 100%) !important;
      color: #fff !important;
      box-shadow: 0 6px 16px rgba(64, 158, 255, 0.35);
      transform: translateX(3px);
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.2),
          transparent
        );
        animation: shimmer 2s infinite;
      }
    }
    @keyframes shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }

  .main-container {
    flex: 1;
    padding: 22px;
    background: linear-gradient(135deg, var(--bg-page) 0%, var(--bg-page) 100%);
    overflow-y: auto;
  }

  // 标签栏外层容器（包含一键清除）
  .tags-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }

  .tags {
    flex: 1;
    background: var(--bg-card);
    border-radius: 18px;
    padding: 14px 18px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    animation: fadeInUp 0.4s ease forwards;
    backdrop-filter: blur(10px);
    border: 1px solid var(--border-base);
  }

  // 一键清除按钮样式
  .clear-tags-btn {
    border-radius: 10px;
    height: 36px;
    padding: 0 14px;
    box-shadow: 0 3px 10px rgba(64, 158, 255, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 14px rgba(64, 158, 255, 0.3);
    }
  }

  .tag-item {
  border-radius: 10px;
  transition: all 0.3s ease;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-base);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
  }

  /* 选中激活态 双主题适配 */
  &.el-tag--dark {
    background: var(--el-color-primary) !important;
    border-color: var(--el-color-primary) !important;
    color: #ffffff !important;
    box-shadow: 0 3px 10px rgba(var(--el-color-primary), 0.3);
  }
}

  .content-box {
    background: var(--bg-card);
    border-radius: 22px;
    padding: 28px;
    min-height: calc(100% - 80px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.35s ease;
    animation: fadeInUp 0.5s ease forwards;
    backdrop-filter: blur(15px);
    border: 1px solid var(--border-base);

    &:hover {
      box-shadow: 0 15px 35px rgba(64, 158, 255, 0.12);
      transform: translateY(-2px);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // ========== 移动端样式 ==========
  &.mobile {
    .sidebar {
      position: fixed;
      top: 60px;
      height: calc(100vh - 60px);
      transform: translateX(-110%);
      border-radius: 0 18px 18px 0;
      box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);

      &.mobile-show {
        transform: translateX(0);
      }
    }

    .main-container {
      padding: 14px;
    }

    .tags-wrapper {
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
    }

    .tags {
      width: 100%;
    }

    .content-box {
      padding: 18px;
      border-radius: 18px;
    }
  }
}

// 退出登录弹窗美化样式
.logout-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  .el-message-box__header {
    padding-top: 22px;
    border-bottom: none;
    text-align: center;
  }
  .el-message-box__title {
    font-size: 19px;
    font-weight: 700;
    color: var(--text-primary);
  }
  .el-message-box__content {
    padding: 0 24px 18px;
    color: var(--text-primary);
  }
  .el-message-box__btns {
    padding: 0 20px 22px;
    display: flex;
    justify-content: center;
    gap: 18px;
  }
}
.cancel-logout-btn {
  border-radius: 10px;
  padding: 9px 28px;
  font-size: 14px;
  font-weight: 500;
}
.confirm-logout-btn {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
  border-radius: 10px;
  padding: 9px 28px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue